export default "__VITE_ASSET__DOkvic4w__"